import TomSelect from 'tom-select';
/**
 * Downloads class
 */
export default class Download {

  /**
   * Constructor of the Downloads class
   */
  constructor($el) {
    this.$el = $el;
    // Caching the required HTML elements and binding event listeners
    this.cacheElements();
    this.bindEvents();

    // This timeout is used to delay the request when typing into the search input
    this.typingTimeout = null;
  }

  /**
   * Caching the required HTML elements
   */
  cacheElements() {
    this.$form = this.$el.querySelector('[name="searchDownloads"]'); // Form element
    this.$queryInput = this.$form.querySelector('[name="tx_frpdownloads_downloads[query]"]'); // Search query input field
    this.checkboxes = this.$form.querySelectorAll('[type="checkbox"]'); // Checkbox inputs
    this.$results = this.$el.querySelector('.downloads-container'); // Downloads results container
    this.$resultTotal = this.$el.querySelector('.downloads-result-total'); // Total results text element
    this.$currentPage = this.$el.querySelector('[name="tx_frpdownloads_downloads[page]"]'); // Current page input field
    this.$isNavigating = this.$el.querySelector('[name="tx_frpdownloads_downloads[isNavigating]"]'); // Is navigating input field
    this.$buttonsContainer = this.$el.querySelector('.frp-downloads-controls'); // Downloads control buttons container
    this.$prevButton = this.$el.querySelector('.frp-downloads-control-prev'); // Previous page button
    this.$nextButton = this.$el.querySelector('.frp-downloads-control-next'); // Next page button
    this.$indicator = this.$el.querySelector('.frp-downloads-indicators'); // Pagination indicators container
    this.categories = this.$form.querySelectorAll('.downloads-categories'); // Downloads categories container
    this.$clearFilters = this.$el.querySelector('#clearFilters'); // Clear filters button
    this.$filters = this.$el.querySelector('.downloads-filters'); // Clear filters button

    this.$showFilters = this.$form.querySelector('.btn-show-filters'); // Show filters button
    this.$showFiltersLabelOn = this.$showFilters.querySelector('.btn-show-filter-label-on'); // Show filters button
    this.$showFiltersLabelOff = this.$showFilters.querySelector('.btn-show-filter-label-off'); // Show filters button
    this.categorySelects = this.$form.querySelectorAll('.category-select');

    this.$iconSwitch = this.$el.querySelector('#iconSwitch'); // Bootstrap switch element for toggling icons

    this.$languageSelect = this.$form.querySelector('.language-select'); // Language selector
  }

  /**
   * Binding required event listeners
   */
  bindEvents() {
    // Prevent form submission and initiate an AJAX request
    this.$form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.sendRequest();
    });

    // Add debounce functionality to the search input field
    this.$queryInput.addEventListener('keyup', this.debouncedRequest.bind(this, 200));

    // Bind click event to the navigation buttons
    this.$prevButton.addEventListener('click', e => this.navigatePage(-1, e));
    this.$nextButton.addEventListener('click', e => this.navigatePage(1, e));


    this.$iconSwitch.addEventListener('change', (e) => this.toggleIcons(e));

    //temporary fix for tom-select styling
    this.$filters.classList.remove('d-none');

    this.categorySelects.forEach($categorySelect => {
      const initialPlaceholder = $categorySelect.dataset.placeholder;

      const tomSelectInstance = new TomSelect($categorySelect, {
        maxItems: null,
        plugins: ['remove_button'],
        // other Tom-select options...
      });

      // check if something is selected
      const hasValue = tomSelectInstance.getValue().length > 0;
      if (hasValue) {
        // If there are selected items, clear the placeholder
        tomSelectInstance.settings.placeholder = '';
        tomSelectInstance.inputState();
      }


      // Event listener for the change event
      $categorySelect.addEventListener('change', () => {
        const hasValue = tomSelectInstance.getValue().length > 0;
        if (hasValue) {
          // If there are selected items, clear the placeholder
          tomSelectInstance.settings.placeholder = '';
          tomSelectInstance.inputState();
        } else {
          // If no items are selected, restore the initial placeholder
          tomSelectInstance.settings.placeholder = initialPlaceholder;
          tomSelectInstance.inputState();
        }

        this.sendRequest();
      });
    });

    if (this.$languageSelect) {
      const initialLanguagePlaceholder = this.$languageSelect.dataset.placeholder;

      const languageTomSelect = new TomSelect(this.$languageSelect, {
        maxItems: 999,
        plugins: ['remove_button'],
        // other Tom Select options...
      });

      const hasValue = languageTomSelect.getValue().length > 0;
      if (hasValue) {
        languageTomSelect.settings.placeholder = '';
        languageTomSelect.inputState();
      }

      this.$languageSelect.addEventListener('change', () => {
        const hasValue = languageTomSelect.getValue().length > 0;
        if (hasValue) {
          languageTomSelect.settings.placeholder = '';
        } else {
          languageTomSelect.settings.placeholder = initialLanguagePlaceholder;
        }
        languageTomSelect.inputState();

        this.sendRequest();
      });
    }

    this.$clearFilters.addEventListener('click', () => {
      this.categorySelects.forEach($categorySelect => {
        $categorySelect.tomselect.clear();
      });
      this.sendRequest();
    });

    this.$showFilters.addEventListener('click', () => this.toggleFilters());
  }

  /**
   * Send an AJAX request to the server
   * @param {boolean} isPageSwitch - Indicate whether the request is triggered by a page switch
   */
  sendRequest(isPageSwitch = false) {
    // The $isNavigating.value is set to 1 if it's a page switch operation, else 0.
    this.$isNavigating.value = isPageSwitch ? 1 : 0

    const formData = new FormData(this.$form);
    const url = this.$form.getAttribute('action');
    const xhr = new XMLHttpRequest();

    xhr.open('POST', url, true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 400) {
        // Parse the returned data and process it differently based on whether it's a page switch operation.
        const data = JSON.parse(xhr.responseText);

        // Update the results based on the response data and whether it's a page switch operation
        isPageSwitch ? this.updateResultsOnPageSwitch(data) : this.updateResults(data);
      } else {
        console.log('error');
      }
    };
    xhr.onerror = () => {
      console.log('downloads xhr error');
    };
    xhr.send(formData);
  }


  /**
   * Update the Downloads results when a page switch occurs
   * @param {Object} data - Data received from the server
   */
  updateResultsOnPageSwitch(data) {
    this.$resultTotal.innerHTML = data.total;

    // Prepare for the transition by setting initial styles
    this.$results.style.transition = '0.2s ease-in-out';
    this.$results.style.height = this.$results.offsetHeight + 'px';
    this.$results.style.opacity = '0';

    setTimeout(() => {
      // If there are results, process them, else display no results message
      if (data.total > 0) {
        this.toggleNoResults(false);
        const downloads = Object.values(data.downloads);
        this.$results.querySelectorAll('.downloads-row').forEach(($downloads) => { $downloads.remove(); });

        // Append new Downloads to the container
        downloads.forEach((downloads) => {
          let $downloads = this.createDownloadsElement(downloads);
          $downloads.classList.add('visible');
          this.$results.appendChild($downloads);
        });
      } else {
        this.toggleNoResults(true);
      }

      // Calculate the total height of new Downloads for transition
      let calculatedHeight = Array.prototype.slice.call(this.$results.children).reduce((acc, $child) => acc + $child.offsetHeight, 0);

      // Initiate the transition to display new Downloads
      this.$results.style.opacity = '1';
      this.$results.style.height = calculatedHeight + 'px';

      // adjust the height to auto after the transition is complete
      setTimeout(() => {
        this.$results.style.height = 'auto';
      }, 200);
    }, 200);

    // emit downloads:updated event
    this.$form.dispatchEvent(new CustomEvent('downloads:updated', { detail: data }));
  }


  /**
   * Update the Downloads results according to the data received from the server
   * @param {Object} data - Data received from the server
   */
  updateResults(data) {
    this.$resultTotal.innerHTML = data.total;

    if (data.total > 0) {
      this.toggleNoResults(false);
      const downloads = Object.values(data.downloads);

      // Remove any Downloads items that are not in the new Downloads list
      this.$results.querySelectorAll('.downloads-row').forEach($oldDownload => {
        const uid = $oldDownload.dataset.uid;
        const isExistingDownload = downloads.some(download => download.uid == uid);

        if (!isExistingDownload) {
          $oldDownload.classList.remove('visible');
          // Remove the old Downloads from the DOM after the fade out animation is finished
          setTimeout(() => $oldDownload.remove(), 200);  // adjust this to match your transition duration
        }
      });

      // Add new Downloads items
      downloads.forEach((download, index) => {
        let $existingDownloads = this.$el.querySelector('[data-uid="' + download.uid + '"]');
        if (!$existingDownloads) {
          // Downloads is new, create element and add it
          let $download = this.createDownloadsElement(download);
          let $prevDownload = this.findExistingDownload(downloads.slice(0, index), true);
          let $nextDownload = this.findExistingDownload(downloads.slice(index + 1));

          // Insert the new Downloads after the previous Downloads but before the next Downloads
          if ($prevDownload) {
            $prevDownload.insertAdjacentElement('afterend', $download);
          } else if ($nextDownload) {
            $nextDownload.insertAdjacentElement('beforebegin', $download);
          } else {
            this.$results.insertAdjacentElement('beforeend', $download);
          }

          // Fade in the new Downloads
          setTimeout(() => $download.classList.add('visible'), 200);
        }
      });
    } else {
      // Remove any Downloads items that are not in the new Downloads list
      this.$results.querySelectorAll('.downloads-row').forEach($oldDownload => {
        $oldDownload.classList.remove('visible');
        // Remove the old Downloads from the DOM after the fade out animation is finished
        setTimeout(() => $oldDownload.remove(), 200);  // adjust this to match your transition duration
      });

      // Display no results message
      setTimeout(() => this.toggleNoResults(true), 201);
    }

    // Update the pagination indicators and category checkboxes
    this.updatePageIndicators(data);
    this.updateCategorySelects(data);

    // emit downloads:updated event
    this.$form.dispatchEvent(new CustomEvent('downloads:updated', { detail: data }));
  }

  /**
   * Update the pagination indicators according to the data received from the server
   * @param {Object} data - Data received from the server
   */
  updatePageIndicators(data) {
    // Clear existing indicators
    this.$indicator.innerHTML = '';

    // If there are more than one page, display the indicators and buttons
    if(data.pages.length > 1) {
      this.$indicator.classList.add('visible');
      this.$buttonsContainer.classList.add('visible');
    } else {
      this.$indicator.classList.remove('visible');
      this.$buttonsContainer.classList.remove('visible');
    }

    // Create new indicators
    data.pages.forEach((page, index) => {
      let span = document.createElement('span');
      span.classList.add('p-1');
      span.classList.add('flex-fill');
      span.dataset.indicator = page;
      span.setAttribute('aria-label', `Page ${page}`);

      // Add 'active' class to the first indicator
      if (index === 0) {
        span.classList.add('active');
      }

      this.$indicator.appendChild(span);
    });

    // Reset current page value to 1
    this.$currentPage.value = 1;
  }

  /**
   * Update the visibility of category filters according to the data received from the server
   * @param {Object} data - Data received from the server
   */
  updateCategorySelects(data) {
    let enableClearFilter = false;
    // Iterate over each category wrapper
    this.categories.forEach($categoryWrapper => {
      const $parent = $categoryWrapper.querySelector('.downloads-category-parent');
      const parentCategoryId = $parent.dataset.categoryid;
      const tomSelectElement = $categoryWrapper.querySelector('.category-select');
      const tomSelectInstance = tomSelectElement.tomselect;

      if (tomSelectInstance.getValue().length > 0) {
        enableClearFilter = true;
      }

      tomSelectInstance.clearOptions();

      // find parentCategory where data.categories[something].parent.uid == parentCategoryId
      const parentCategory = Object.values(data.categories).find(category => category.parent && category.parent.uid == parentCategoryId);

      if (parentCategory) {
        Object.values(parentCategory.children).forEach(childCategory => {
          tomSelectInstance.addOption({
            value: childCategory.uid,
            text: childCategory.title
          });
        });

        $categoryWrapper.classList.remove('d-none');
      } else {
        $categoryWrapper.classList.add('d-none');
      }

      tomSelectInstance.close();
    });

    enableClearFilter ? this.$clearFilters.classList.add('visible') : this.$clearFilters.classList.remove('visible');
    this.calculateFiltersHeight();
  }

  /**
   * Create a new Downloads HTML element
   * @param {Object} download - The Downloads object
   * @returns {HTMLElement} The newly created Downloads HTML element
   */

  createDownloadsElement(download) {
    const template = document.getElementById('download-template');
    if(!template) {
      return false;
    }

    const $download = document.importNode(template.content, true);
    $download.querySelector('.downloads-row').dataset.uid = download.uid;
    const downloadName = download.title ? download.title : download.name;
    const iconOrImage = download.isImageOrPdf ? `<img src="${download.thumbnailPath}" alt="${downloadName}" class="img-fluid">` : `<i class="far fa-file-${download.icon}"></i>`;
    const isIconVisible = this.$iconSwitch.checked ? '' : 'd-none';

    // Setting attributes and innerHTML
    $download.querySelector('.downloads-row a').href = download.path;
    $download.querySelector('.download-icon-container').innerHTML = iconOrImage;
    if(isIconVisible) {
      $download.querySelector('.download-icon-container').classList.add(isIconVisible);
    }

    let parsedDate = new Date(Date.parse(download.modified));
    // translate the date to the current locale

    let htmlLang = document.documentElement.lang || 'en'; // fallback falls kein lang gesetzt ist
    let modifiedDate = parsedDate.toLocaleDateString(htmlLang, {
      year: 'numeric',
      month: 'long',
      day: '2-digit'
    });

    $download.querySelector('.download-date').textContent = modifiedDate;
    $download.querySelector('.download-name').textContent = downloadName;

    this.renderCategories($download, download.categories);
    //$download.querySelector('.download-categories').innerHTML = this.renderCategories(download.categories);

    if(download.frp_external_link) {
      $download.querySelector('.download-frp-external-link>a').href = download.frp_external_link;
      $download.querySelector('.download-frp-external-link').classList.remove('d-none');
    }

    // we have to append the document-fragment to a htmlElement so it can be processed as a HTMLElement
    const $downloadElement = document.createElement('div');
    $downloadElement.appendChild($download);

    return $downloadElement.querySelector('.downloads-row');
  }


  /**
   * Render the HTML for Downloads categories
   * @param {Array} categories - The categories data
   * @returns {string} The HTML string for the categories
   */
  renderCategories($download, categories) {
    // use a bade with ##color## and ##title## to render the categories
    let badgeTemplate = $download.querySelector('.download-categories .badge');
    let html = '';
    if(badgeTemplate) {
      for (const [key, category] of Object.entries(categories)) {
        let badge = badgeTemplate;
        let classes = badge.classList.value.replaceAll('##color##', category.color);
        badge.classList.value = classes;
        badge.textContent = category.title;

        html += badge.outerHTML;
      }

    } else {
      let html = '';
      for (const [key, category] of Object.entries(categories)) {
        html += `
          <span class="badge badge-${category.color}">${category.title}</span>
        `;
      };
    }

    $download.querySelector('.download-categories').innerHTML = html;
  }

  /**
   * Navigate through the Downloads pages
   * @param {number} delta - The direction and amount of pages to navigate
   * @param {Event} e - The event object
   */
  navigatePage(delta, e) {
    e.preventDefault();
    const indicators = this.$indicator.querySelectorAll('span');

    // Get the next indicator via the current page value and the delta (there has to be a -1 because the delta is 1 or -1 and not 0 or 1)
    const nextIndicator = indicators[this.$currentPage.value - 1 + delta];
    const activeIndicator = this.$indicator.querySelector('span.active');

    // If there is a next indicator, update the current page value and send the request
    if(nextIndicator) {
      this.$currentPage.value = parseInt(this.$currentPage.value) + delta;
      activeIndicator.classList.remove('active');
      nextIndicator.classList.add('active');

      this.sendRequest(true);
    }
  }

  /**
   * Toggle the visibility of the "No results" message
   * @param {boolean} isVisible - The visibility state
   */
  toggleNoResults(isVisible) {
    const $noResults = this.$results.querySelector('.downloads-no-results');
    if(isVisible) {
      $noResults.classList.remove('d-none');
    } else {
      $noResults.classList.add('d-none');
    }
  }

  /**
   * Toggle the visibility of the categories
   */
  toggleFilters() {
    if(!this.$filters.classList.contains('visible')) {
      this.calculateFiltersHeight();
      this.$filters.classList.add('visible');
      this.$showFiltersLabelOn.classList.add('d-none');
      this.$showFiltersLabelOff.classList.remove('d-none');
    } else {
      this.$filters.style.height = '0px';
      this.$filters.classList.remove('visible');
      this.$showFiltersLabelOn.classList.remove('d-none');
      this.$showFiltersLabelOff.classList.add('d-none');
    }
  }

  calculateFiltersHeight() {
    let filtersChildren = this.$filters.children;
    filtersChildren = Array.prototype.slice.call(filtersChildren);

    let calculatedHeight = 0;

    filtersChildren.forEach($child => {
      calculatedHeight += $child.offsetHeight;
    });

    this.$filters.style.height = `${calculatedHeight}px`;
  }

  /**
   * Toggle the visibility of download icons on mobile
   */
  toggleIcons(e) {
    const downloadIcons = this.$el.querySelectorAll('.download-icon'); // Download icons
    const isChecked = e.target.checked;

    // Show or hide icons based on the switch's checked state
    downloadIcons.forEach($icon => {
      if (isChecked) {
        $icon.classList.remove('d-none');
      } else {
        $icon.classList.add('d-none');
      }
    });
  }

  /**
   * Find an existing Downloads element
   * @param {Array} downloads - Array of Downloads
   * @param {boolean} reverse - Whether to reverse the search direction
   * @returns {HTMLElement|null} The existing Downloads element or null if not found
   */
  findExistingDownload(downloads, reverse = false) {
    if(reverse) downloads = downloads.reverse();

    for (let download of downloads) {
      let $download = this.$el.querySelector('[data-uid="' + download.uid + '"]');
      if ($download) return $download;
    }

    return null;
  }

  /**
   * Send an AJAX request with a delay after the user stops typing
   * @param {number} delay - Delay time in milliseconds
   */
  debouncedRequest(delay) {
    clearTimeout(this.typingTimeout);
    this.typingTimeout = setTimeout(this.sendRequest.bind(this), delay);
  }
}
